import { BannerType } from './types';

// TODO: This file needs to be migrated to a `en.json`

export const i18n = {
    // TODO: Reconsider all of this content.
    iconAlt: {
        [BannerType.Info]: 'This message might be helpful to you',
        [BannerType.Success]: 'A task has been successfully completed',
        [BannerType.Warning]: 'A warning has occured and warrants your consideration',
        [BannerType.Error]: 'An error has occured and requires your attention',
    },
    // TODO: We may want to qualify this by each type of Banner.
    close: 'Acknowledge and dismiss this message',
};

export function getIconAlt(type: BannerType = BannerType.Info) {
    return i18n.iconAlt[type];
}
